import React, { useContext } from "react";
import SubItem from "./subItem";
import { ItemLink, MainItemLink, MenuContainer, MenuItems, NavigationBarSecond } from "./style";
import PropTypes from "prop-types";
import { LanguageContext } from "../../core/store";

const MainItem = ({ path, translateKey, children, menuId, menuList, handleClick }) => {

    const { translate } = useContext(LanguageContext);

    let isActive = false;
    const selected = path.split("/")[1];
    const selectedPath = window.location.pathname.split("/")[1];

    if (selected === selectedPath) {
        isActive = true;
    }

    if (selected === ":type-ekran" && (selectedPath === "tekli-ekran" || selectedPath === "coklu-ekran")) {
        isActive = true;
    }

    return (
        <>
            {children ? (
                <MainItemLink active={isActive} onClick={() => handleClick(menuId)}>
                    {translate(translateKey)}
                </MainItemLink>
            ) : (
                <ItemLink to={path}>{translate(translateKey)}</ItemLink>
            )}

            {menuList[menuId] && children && (
                <NavigationBarSecond>
                    <MenuContainer>
                        {children.map((item, index) => (
                            <MenuItems key={item.path}>
                                <SubItem menuId={`${menuId}-submenu-${index}`} handleClick={handleClick}
                                         menuList={menuList} {...item} />
                            </MenuItems>
                        ))}
                    </MenuContainer>
                </NavigationBarSecond>
            )}
        </>
    );
};

MainItem.propTypes = {
    path: PropTypes.string,
    translateKey: PropTypes.string.isRequired,
    children: PropTypes.any,
    menuId: PropTypes.string.isRequired,
    menuList: PropTypes.object.isRequired,
    handleClick: PropTypes.func.isRequired
};

export default MainItem;
